import './FileList.scss';

export { default } from './FileList';
